import { contactSales } from "./contactSupport";
import { bookSmartPricingConsultation } from "./linkSheet";
import { openNewTab } from "./openNewTab";

/**
 * Routes every Smart Pricing "talk to a specialist" CTA.
 *
 * The consult calendar is staffed by CS for existing paying customers adding
 * Smart Pricing to a subscription they already pay for. Trials and net-new
 * installs are leads, not upgrades, and belong with Sales — booking them onto
 * the CS calendar lands them on the wrong call. Every specialist CTA routes
 * through here so the two audiences cannot drift apart again.
 */
export const contactSmartPricingSpecialist = (
  isExistingCustomer: boolean
): void => {
  if (isExistingCustomer) {
    openNewTab(bookSmartPricingConsultation);
    return;
  }
  contactSales();
};
